// extracted by mini-css-extract-plugin
module.exports = {"Text":"Power_Text__1hj1Z","Value":"Power_Value__2__KF","Small":"Power_Small__3yTuW","Unit":"Power_Unit__1gXvk"};